"use client";
import Container from "@/components/Container";
import React from "react";

import { PrismicNextImage } from "@prismicio/next";
import useEmblaCarousel from "embla-carousel-react";
import { usePrevNextButtons } from "@/slices/Awards/ArrowButtons";
import clsx from "clsx";

const Awards = ({ slice }) => {
  // const settingsMobile = {
  //   dots: false,
  //   arrows: false,
  //   autoplay: true,
  //   infinite: true,
  //   autoplaySpeed: 2000,
  //   speed: 2000,
  //   delay: 0,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   cssEase: "linear",
  // };
  // const settingsDesktop = {
  //   arrows: true,
  //   autoplay: false,
  //   infinite: true,
  //   slidesToShow: 7,
  //   slidesToScroll: 1,
  //   nextArrow: <NextArrow />,
  //   prevArrow: <PrevArrow />,
  // };

  const [emblaRef, emblaApi] = useEmblaCarousel({ align: "start" });

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <Container slice={slice} className="bg-[#EFEFEF]">
        <div className="flex items-center justify-between">
          <Arrow onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <section className="embla-awards">
            <div className="embla__viewport" ref={emblaRef}>
              <div className="embla__container">
                {slice?.primary?.images.map((item, index) => (
                  <div className="embla__slide" key={index}>
                    <PrismicNextImage
                      field={item?.image}
                      fallbackAlt=""
                      className="desktop-award block mx-auto"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </section>
          <Arrow onClick={onNextButtonClick} disabled={nextBtnDisabled} next />
        </div>
      </Container>
    </section>
  );
};

export default Awards;

const Arrow = (props) => {
  const { className, onClick, disabled, next = false } = props;
  return (
    <div
      className={clsx({
        "before:hidden py-[12px] px-[18px] hidden lg:block": true,
        "opacity-50 pointer-events-none": disabled,
        "!cursor-pointer": !disabled,
        [className]: true,
      })}
      onClick={onClick}
    >
      {next ? <NextArrow /> : <PrevArrow />}
    </div>
  );
};

function NextArrow() {
  return (
    <div className="w-[28px] h-[28px] border-r-[2.5px] border-b-[2.5px] border-r-[#C4C4C8] border-b-[#C4C4C8] hover:scale-[1.15] transition-all 0.3s ease-linear -rotate-[45deg]" />
  );
}

function PrevArrow() {
  return (
    <div className="w-[28px] h-[28px] border-r-[2.5px] border-b-[2.5px] border-r-[#C4C4C8] border-b-[#C4C4C8] hover:scale-[1.15] transition-all 0.3s ease-linear rotate-[135deg]" />
  );
}
